import { render } from "./AbrirCaja.vue?vue&type=template&id=66d1dbe7"
import script from "./AbrirCaja.vue?vue&type=script&lang=js"
export * from "./AbrirCaja.vue?vue&type=script&lang=js"

import "./AbrirCaja.vue?vue&type=style&index=0&id=66d1dbe7&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__